<template>
  <section class="save-complete-modal">
    <modal-template>
      <template #card-title>
        <icon
          icon="check"
          size="l"
        />
        Gelukt
      </template>
      <template #comparison-data>
        <div
          v-if="savedComparison.location_object"
          class="usp"
        >
          <icon icon="x-fa-house" />
          <span>{{ savedComparison.location_object.display }}</span>
        </div>
        <slot name="market-usps" />
        <div
          v-if="computedComparison.friend_id"
          class="usp"
        >
          <icon icon="x-fa-user" />
          <span>{{ friendName }}</span>
        </div>
        <div
          v-if="receiver === 'other' && computedComparison.first_name"
          class="usp"
        >
          <icon icon="x-fa-user" />
          <span>Voor {{ computedComparison.first_name }}</span>
        </div>
      </template>
      <template #content>
        <slot name="text-content">
          <div v-html="modalContent" />
        </slot>
      </template>
      <template #inputs>
        <div class="note">
          We slaan de vergelijking 14 dagen op.
          Tijdens deze periode kunnen de prijzen veranderen.
        </div>

        <modal-hook name="save-comparison">
          <template #content>
            <button-icon-right
              type="cta"
              label="Verder met vergelijken"
            />
          </template>
        </modal-hook>
      </template>
    </modal-template>
  </section>
</template>

<script>

import Icon from 'vue-elements/icon/Icon.vue';
import CardDefault from '../../../elements/card/default/cardDefault.vue';
import TextFieldElement from '../../../elements/field/text/default/textDefault.vue';
import ButtonIconRight from '../../../elements/button/icon-right/button-icon-right.vue';
import ModalTemplate from '../shared/ModalTemplate.vue';
import ModalHook from '../../../elements/modal/_shared/hook/modalHook.vue';
import saveComparisonModal from '../assets/js/saveComparisonModal.js';

export default {
    name: 'SaveCompleteModal',
    components: {
        ModalHook,
        ModalTemplate,
        ButtonIconRight,
        TextFieldElement,
        CardDefault,
        Icon,
    },
    mixins: [saveComparisonModal],
    props: {
        savedComparison: Object,
    },
    computed: {
        modalContent() {
            if (this.receiver === 'self' && this.signedIn) {
                return '<p>Je internet vergelijking is opgeslagen. Je vind deze terug bij je <a class="text-link" href="/mijnkeuze/bewaarde-vergelijkingen">Bewaarde vergelijkingen</a> in je Mijn Keuze account.</p>'
                    + `<p>We hebben ook een overzicht van deze vergelijking naar <span class="bold-text">${this.confirmEmailAddress}.</span> gestuurd.</p>`;
            }
            if (this.receiver === 'self') {
                return `<p>Een overzicht van deze vergelijking is verstuurd naar <span class="bold-text">${this.confirmEmailAddress}.</span> </p>`
                    + '<p>Maak een <a class="text-link" href="/mijnkeuze">Mijn Keuze account</a> aan om al je vergelijkingen en contracten op één plek te bewaren. </p>';
            }
            if (this.receiver === 'friend') {
                return `<p>Deze vergelijking is gedeeld! <span class="bold-text"> ${this.friendName}</span> vindt de vergelijking terug in zijn/haar <span class="bold-text">Bewaarde vergelijkingen</span>. Hiernaast wordt eenmalig een overzicht van deze vergelijking verstuurd per mail. </p> `
                    + `<p>Je kan deze vergelijking zelf ook terug vinden in je <a class="text-link" href="/mijnkeuze/vrienden/${this.comparison.friend_id}">Vriendenoverzicht</a> in je Mijn Keuze account.</p>`;
            }
            return `Deze vergelijking is verstuurd naar <span class="bold-text">${this.confirmEmailAddress}.</span>`;
        },
    },
};
</script>
